import axios from "axios";
import store from "@/store";

let isRefreshing = false;
let pendingQueue = [];

function processQueue(error, token) {
  pendingQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve(token);
  });
  pendingQueue = [];
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;

    if (
      !response ||
      response.status !== 401 ||
      !config ||
      config._retry ||
      config.url?.includes("/auth/")
    ) {
      return Promise.reject(error);
    }

    if (!store.getters.getRefreshToken && !store.getters.refresh) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject });
      }).then((token) => {
        config._retry = true;
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
        return axios(config);
      });
    }

    config._retry = true;
    isRefreshing = true;

    try {
      const newAccessToken = await store.dispatch("refreshAccessToken");
      isRefreshing = false;

      if (!newAccessToken) {
        processQueue(error, null);
        return Promise.reject(error);
      }

      processQueue(null, newAccessToken);
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${newAccessToken}`,
      };
      return axios(config);
    } catch (refreshError) {
      isRefreshing = false;
      processQueue(refreshError, null);
      return Promise.reject(refreshError);
    }
  }
);
